export default "__VITE_ASSET__ZrK1muVk__"